const report1099 = {
  reportSuccessfullySaved: "Your 1099 return was successfully saved!",
  reportSuccessfullySubmitted: "Your 1099 return was successfully submitted!",
};

export default report1099;
